import { render, staticRenderFns } from "./OffersCard.vue?vue&type=template&id=74e56186&scoped=true&"
import script from "./OffersCard.vue?vue&type=script&lang=js&"
export * from "./OffersCard.vue?vue&type=script&lang=js&"
import style0 from "./OffersCard.vue?vue&type=style&index=0&id=74e56186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e56186",
  null
  
)

export default component.exports